import { useAtom } from 'jotai';
import Link from 'next/link';
import { GrClear } from 'react-icons/gr';
import InfiniteScroll from 'react-infinite-scroller';

import { pageLoading } from '@/lib/store';
import { IListingItem } from '@/modules/core/types';
import { genItemLink } from '@/modules/core/utils/utils';

import AdCard from './ListingItemCard/AdCard';
import { AdType } from './ListingItemCard/types';
import Text from './Text';

interface AdListProps {
  adListData: IListingItem[];
  loadMoreAds: () => void;
  showSelction: boolean;
  showAdList: boolean;
  setShowSelction: (s: boolean) => void;
  balance: number;
}

const AdList = ({
  adListData,
  loadMoreAds,
  showSelction,
  showAdList,
}: AdListProps) => {
  const [isLoading] = useAtom(pageLoading);

  // @ts-ignore
  // @ts-ignore
  return (
    <div className="mt-8 h-full">
      {isLoading ? (
        'Loading...'
      ) : !isLoading && adListData.length === 0 ? (
        <div className="flex flex-col items-center w-1/2 mx-auto gap-y-12 my-12">
          <div className="alert alert-warning shadow-lg">
            <div>
              <GrClear />
              <Text
                text="Vous n'avez pas des annonces"
                className="font-arabic"
              />
            </div>
          </div>

          <img
            src="/media/undraw_not_found_-60-pq.svg"
            alt="No results found for your search on tayara"
          />
        </div>
      ) : (
        !showSelction &&
        showAdList && (
          <InfiniteScroll
            loadMore={loadMoreAds}
            hasMore={true}
            initialLoad={false}
            threshold={5000}
          >
            <div className="flex flex-wrap justify-evenly lg:justify-around xl:justify-center p-6 mb-4 gap-y-5 gap-x-0 lg:gap-x-4 xl:gap-x-4">
              {adListData?.map((adCardData, index) => (
                <div
                  key={`${index}-${adCardData.id}`}
                  className="col-span-12 sm:col-span-6 lg:col-span-4 cursor-pointer"
                >
                  <label>
                    <Link href={{ pathname: genItemLink(adCardData) }} passHref>
                      <span className="cursor-pointer">
                        <AdCard
                          isMyListing
                          adType={AdType.Normal}
                          adCardData={adCardData}
                          className="cursor-pointer"
                        />
                      </span>
                    </Link>
                  </label>
                </div>
              ))}
            </div>
          </InfiniteScroll>
        )
      )}
    </div>
  );
};

export default AdList;
